export const MY_INTERVIEW_JOBS = {
    CANDIDATE_INTERVIEW: 'Candidate video Q&A',
    USER_INTRODUCTION: 'Client user video introduction',
    CANDIDATE_INTRODUCTION: 'Agency candidate introduction'
 }